import './overlaywrapper.scss';

export default function OverlayWrapper (content) {
    this.element = document.createElement('div');
    this.element.classList.add('overlay-inner-wrapper');

    return this.element;
}
    
